import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { toNumber } from "../components/Common";
// import _debounce from 'lodash/debounce';
// Material UI

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import Tooltip from "@material-ui/core/Tooltip";

//redux

export const WhiteInputAdornment = withStyles({
    root: {
        color: "white !important",
    },
    positionEnd: {
        color: "white !important",
    },
})(InputAdornment);

function Adornment(props) {
    return (
        <span
            style={{
                ...(props.style ? props.style : {}),
                color: props.dark ? "#1729af" : "#adb3d9",
                fontWeight: "400",
            }}
        >
            {props.text}
        </span>
    );
}

const useStyles = makeStyles({
    grow: {
        flexGrow: 1,
    },
    closeButton: {
        float: "right",
        marginTop: "0px",
        marginRight: "-20px",
        color: "white",
    },
    pdfLink: {
        backgroundColor: "#c8d9e1",
    },
});

export function JobTextField(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const [text, setText] = React.useState(false);

    // const { classes, updateJobState, validateJobState, job } = props.parentProps;
    const { style, labelStyle, endAdornment, helperText, helperTextStyle, adornmentText, onBlur } = props;
    const { Customer, ErrorMap } = job;
    let label = props.label ? props.label : props.dataField;
    let classNames = props.classes ? props.classes : classes.formControl;

    var combined_input_style = { width: "80px", color: "white", marginRight: "10px" };
    if (style) combined_input_style = Object.assign(combined_input_style, style);

    // let SectionErrorMap = null;
    // let has_no_errors = true;
    // if (ErrorMap && ErrorMap[props.section]) {
    //     SectionErrorMap = ErrorMap[props.section];
    // }

    const handleBlur = () => {
        let outValue = text !== false ? text : value;
        if (props.max !== null || props.min !== null) {
            outValue = toNumber(outValue);
            if (props.allowZero && outValue === 0) {
            } else if (props.max !== null && Number(outValue) > Number(props.max)) outValue = props.max;
            else if (props.min !== null) if (Number(outValue) < Number(props.min)) outValue = props.min;
        }

        if (onBlur && outValue !== value) onBlur(outValue);
        setText(false);
    };

    let value = props.value
        ? props.value
        : props.subsection
        ? job[props.section][props.subsection][props.dataField]
        : job[props.section][props.dataField];
    if (value === null) value = undefined;
    let error = null;
    if (ErrorMap && ErrorMap[props.section])
        error = props.subsection
            ? ErrorMap?.[props.section]?.[props.subsection]?.[props.dataField]
            : ErrorMap[props.section]?.[props.dataField];

    return (
        <TextField
            className={classNames}
            id={props.dataField}
            label={label}
            value={value}
            error={error ? true : false}
            helperText={error ? error : helperText ? helperText : ""}
            // onChange={(e) => dispatch(updateJobState(props.section, (props.subsection ? props.subsection + "." : "") + props.dataField, e.target.value))}
            // onBlur={(e) => dispatch(validateJobState(props.section, (props.subsection ? props.subsection + "." : "") + props.dataField, e.target.value))}

            onChange={(e) => setText(e.target.value)}
            onBlur={handleBlur}
            onKeyPress={(e) => {
                if (e.key === "Enter" && props.blurOnEnter) {
                    e.target.blur();
                }
            }}
            InputProps={{
                endAdornment: endAdornment ? endAdornment : adornmentText ? <Adornment text={adornmentText} /> : null,
                style: combined_input_style,
            }}
            InputLabelProps={{
                style: labelStyle ? labelStyle : { color: "#b4bdff" },
            }}
            FormHelperTextProps={{
                className: classes.helper,
                style: helperTextStyle
                    ? helperTextStyle
                    : {
                          color: "#FFEB3B",
                          fontStyle: "italic",
                      },
            }}
        />
    );
}

export function AreaTextField(props) {
    const classes = useStyles();
    const [text, setText] = React.useState(false);

    const {
        style,
        root_style,
        labelStyle,
        endAdornment,
        startAdornment,
        helperText,
        helperTextStyle,
        onBlur,
        disabled,
        adornmentText,
        error,
        value,
        disableTooltip,
        dark,
    } = props;
    let classNames = props.classes ? props.classes : classes.formControl;

    var combined_input_style = {
        width: "80px",
        color: disabled ? "grey" : dark ? "black" : "white",
        marginRight: "10px",
    };
    if (style) combined_input_style = Object.assign(combined_input_style, style);

    const handleBlur = () => {
        let outValue = text !== false ? text : value;
        if (props.max !== null || props.min !== null) {
            outValue = toNumber(outValue);
            if (props.allowZero && outValue === 0) {
            } else if (props.max !== null && Number(outValue) > Number(props.max)) outValue = props.max;
            else if (props.min !== null) if (Number(outValue) < Number(props.min)) outValue = props.min;
        }

        if (onBlur && outValue !== value) onBlur(outValue);
        setText(false);
    };

    let tooltip = "";
    if (props.min !== null && props.min !== undefined) tooltip += "Min:" + props.min;
    if (props.max !== null && props.max !== undefined) tooltip += (tooltip === "" ? "" : " ") + "Max:" + props.max;

    let display_value = text !== false ? text : value;
    if (display_value === null) display_value = undefined;

    return (
        <Tooltip
            arrow
            disableFocusListener={disableTooltip || tooltip === ""}
            disableHoverListener={disableTooltip || tooltip === "" || true}
            title={tooltip}
            placement="bottom-end"
        >
            <TextField
                disabled={disabled}
                className={classNames}
                style={root_style ? root_style : {}}
                id={props.dataField}
                label={props.label}
                value={display_value}
                error={error ? true : false}
                helperText={error ? error : helperText ? helperText : ""}
                onChange={(e) => setText(e.target.value)}
                onBlur={handleBlur}
                onKeyPress={(e) => {
                    if (e.key === "Enter" && props.blurOnEnter) {
                        e.target.blur();
                    }
                }}
                InputProps={{
                    startAdornment: startAdornment ? startAdornment : null,
                    endAdornment: endAdornment ? (
                        endAdornment
                    ) : adornmentText ? (
                        <Adornment dark={dark} text={adornmentText} />
                    ) : null,
                    style: combined_input_style,
                    inputProps: {
                        style: props.inputStyle,
                        min: props.min !== null ? props.min : null,
                        max: props.max !== null ? props.max : null,
                    },
                }}
                InputLabelProps={{
                    style: labelStyle ? labelStyle : { color: "#b4bdff" },
                }}
                FormHelperTextProps={{
                    className: classes.helper,
                    style: helperTextStyle
                        ? helperTextStyle
                        : {
                              color: error ? "#ff9292" : dark ? "#be832c" : "#FFEB3B",
                              fontSize: "x-small",
                              whiteSpace: "pre-wrap",
                              maxWidth: "fit-content",
                          },
                    error: error ? true : false,
                }}
            />
        </Tooltip>
    );
    // };
}

// export const connect(mapStateToProps, importedActions)(withStyles(styles)(AreaSelectField));

// const importedActions = { changePage, toggleDesigner, toggle3DDesigner, updateAreaSpecification };
// export const StyledAreaSelectField = connect({}, importedActions)(withStyles()(AreaSelectField));

export class AreaSelectFieldx extends React.Component {
    render() {
        const { props } = this;
        const {
            classes,
            style,
            labelStyle,
            helperText,
            helperTextStyle,
            onChange,
            areaIndex,
            section,
            dataField,
            value,
            labelText,
            menuItems,
        } = props;

        let menu_items = [];
        for (let menuItem of menuItems) {
            if (typeof menuItem === "string") {
                menu_items.push(
                    <MenuItem key={menuItem} value={menuItem}>
                        {menuItem}
                    </MenuItem>
                );
            } else {
                menu_items.push(menuItem);
            }
        }

        return (
            <>
                <FormControl style={{ width: "100%", textAlign: "left" }}>
                    <InputLabel
                        htmlFor="roofsheetType"
                        shrink={true}
                        className={classes.whiteText}
                        // FormLabelClasses={classes}
                        FormLabelClasses={{
                            root: classes.cssLabel,
                        }}
                    >
                        {labelText}
                    </InputLabel>
                    <Select
                        value={value}
                        className={classes.select}
                        onChange={(event) =>
                            this.props.updateAreaSpecification(areaIndex, section, dataField, event.target.value)
                        }
                        name={section + "." + dataField}
                        input={
                            <Input
                                classes={{
                                    focused: classes.orangeText,
                                    underline: classes.underline,
                                }}
                                name="roofsheetType"
                                id="roofsheetType"
                            />
                        }
                        // classes={classes}
                    >
                        {menu_items}
                    </Select>
                    {helperText !== null && <FormHelperText>Some important helper text</FormHelperText>}
                </FormControl>
            </>
        );
    }
}
// AreaSelectField.propTypes = {
//     // ...prop type definitions here
//     section: PropTypes.string.isRequired,
//     dataField: PropTypes.string.isRequired,
//     selectValues: PropTypes.array.isRequired,
//     /// values can just ba a string array
//     /// but if it is an object array, you need to specify valueKey and displayKey
//     // valueKey: PropTypes.string.isRequired,
//     // displayKey: PropTypes.string.isRequired,
// }
